import { formatPrice, type Plan } from "../lib/types";

/** A plan's price as the person pays it, with the original struck through when discounted (ADR-0033). */
export function Price({ plan, per = true, size = "lg", prefix }: { plan: Pick<Plan, "price" | "list_price" | "discount" | "currency" | "interval">; per?: boolean; size?: "lg" | "sm"; prefix?: string }) {
  const was = plan.list_price != null && plan.list_price > plan.price ? plan.list_price : null;
  if (plan.price === 0 && was == null) return <span className={size === "lg" ? "price" : "price-sm"}>Free</span>;
  return (
    <span className={`price-wrap ${size}`}>
      {prefix && <span className="price-per">{prefix}</span>}
      <span className={size === "lg" ? "price" : "price-sm"}>
        {formatPrice(plan.price, plan.currency)}
        {per && <span className="price-per"> / {plan.interval === "year" ? "year" : "month"}</span>}
      </span>
      {was != null && (
        <>
          <s className="price-was" aria-label={`was ${formatPrice(was, plan.currency)}`}>{formatPrice(was, plan.currency)}</s>
          {plan.discount && <span className="pill ok price-off">−{plan.discount.percent}%</span>}
        </>
      )}
    </span>
  );
}

/** "20% off until 31 Oct" for a discounted plan. */
export function discountNote(plan: Pick<Plan, "discount">): string | null {
  const d = plan.discount;
  if (!d) return null;
  const until = d.ends_at ? ` for subscriptions started until ${new Date(new Date(d.ends_at).getTime() - 1).toLocaleDateString()}` : "";
  return `${d.percent}% off${d.note ? ` · ${d.note}` : ""}${until}. You keep this price while you stay subscribed.`;
}
